import { onMounted, onUnmounted } from 'vue';

const ZOOM_KEYS = new Set(['+', '-', '=', '0', 'Add', 'Subtract', 'Equal', 'Minus', 'Digit0']);

export function useLockBrowserZoom() {
  const preventDefault = (event: Event) => {
    event.preventDefault();
  };

  const preventZoomWheel = (event: WheelEvent) => {
    if (!event.ctrlKey && !event.metaKey) return;

    event.preventDefault();
  };

  const preventZoomKey = (event: KeyboardEvent) => {
    if (!event.ctrlKey && !event.metaKey) return;
    if (!ZOOM_KEYS.has(event.key) && !ZOOM_KEYS.has(event.code)) return;

    event.preventDefault();
  };

  const preventPinchZoom = (event: TouchEvent) => {
    if (event.touches.length < 2) return;

    event.preventDefault();
  };

  onMounted(() => {
    document.addEventListener('wheel', preventZoomWheel, { passive: false, capture: true });
    document.addEventListener('keydown', preventZoomKey, { capture: true });
    document.addEventListener('touchmove', preventPinchZoom, { passive: false, capture: true });
    document.addEventListener('gesturestart', preventDefault, { passive: false });
    document.addEventListener('gesturechange', preventDefault, { passive: false });
    document.addEventListener('gestureend', preventDefault, { passive: false });
  });

  onUnmounted(() => {
    document.removeEventListener('wheel', preventZoomWheel, { capture: true });
    document.removeEventListener('keydown', preventZoomKey, { capture: true });
    document.removeEventListener('touchmove', preventPinchZoom, { capture: true });
    document.removeEventListener('gesturestart', preventDefault);
    document.removeEventListener('gesturechange', preventDefault);
    document.removeEventListener('gestureend', preventDefault);
  });
}
